import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/app.scss'
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

reportWebVitals();
